import { inputHandler } from './input';
import { checkboxHandler } from './checkbox';
import { isMobileScreen } from './utils';

const PROGRESS_HTML = `
<div class="product-qualification_response">
  <img src="/assets/images/progress-circle.svg" aria-hidden="true" alt="" class="progress-circle">
  <p>Processing your results...</p>
</div>
`;

const fieldValidationCondition = (item) => {

  if (item.type === 'checkbox') {
    return item.checked;
  }

  const isRequired = item.getAttribute('required') === 'true';
  const hasError = item.classList.contains('input_error');

  if (isRequired) return item.value?.length > 0 && !hasError;

  return true;
};

const checkIfFormIsValid = (submitButton, fields) => {

  if (!fields) return;

  let isValid = true;

  for (let i = 0; i < fields.length; i++) {

    if (fields[i].name === '__RequestVerificationToken') continue;

    const isFieldValid = fieldValidationCondition(fields[i]);
    if (!isFieldValid) {
      isValid = false;
      break;
    }
  }

  if (isValid) {
    return submitButton.removeAttribute('disabled');
  }
  return submitButton.setAttribute('disabled', '');
};

const onFormSubmit = async(e, formFields, formContainer, form) => {
  e.preventDefault();

  if (!formFields) return;

  const body = {};
  let isValid = true;

  for (let i = 0; i < formFields.length; i++) {

    if (formFields[i].name === '__RequestVerificationToken') continue;

    const isFieldValid = fieldValidationCondition(formFields[i]);
    if (!isFieldValid) {
      isValid = false;
      break;
    }
    body[formFields[i].id] = formFields[i].type === 'checkbox' ? formFields[i].checked : formFields[i].value;
  }

  if (isValid) {
    const tokenElement = document.querySelector('input[name="__RequestVerificationToken"]');
    const token = tokenElement.value;
    const apiUrl = form.getAttribute('data-api-url');
    const formKey = form.getAttribute('data-form-key');
    const recaptchaPublicKey = form.getAttribute('data-recaptcha-public-key');
    const firstName = body['first-name'];
    const lastName = body['last-name'];
    const idNumber = body['id-number'];
    const emailAddress = body['email'];
    const mobileNumber = body['mobile'];
    const totalIncome = body['income'];

    window.grecaptcha.ready(async() => {
      const recaptchaToken = await window.grecaptcha.execute(recaptchaPublicKey, { action: 'submit' });

      const formRequest = {
        formKey,
        firstName,
        lastName,
        idNumber,
        emailAddress,
        mobileNumber,
        totalIncome,
        recaptchaToken
      };

      formContainer.innerHTML = PROGRESS_HTML;

      try {
        const res = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'RequestVerificationToken': token
          },
          body: JSON.stringify(formRequest)
        });
        const html = await res.text();
        if (html) formContainer.innerHTML = html;

      } catch (error) {
        console.error(error);
      }
    });
  }
};

const setHeaderHeight = (header) => {

  const children = header.querySelectorAll('*');
  let maxHeight = 0;

  children.forEach((child) => {
    const childRect = child.getBoundingClientRect();
    const childHeight = childRect.height;
    maxHeight += childHeight;
  });

  const elementHeight = header.offsetHeight + maxHeight;
  header.style.height = `${elementHeight}px`;

};

const onProductQualificationLoad = () => {
  const productQualification = document.getElementById('product-qualification');

  if (!productQualification) return;
  const header = productQualification.querySelector('.product-qualification_banner');
  const form = productQualification.querySelector('[data-prod-qualify-form]');
  const formContainer = productQualification.querySelector('.product-qualification_content');
  const inputs = form.querySelectorAll('[data-input-field]');
  const checkbox = form.querySelectorAll('[data-checkbox-field]');
  const submitButton = form.querySelector('button[type="submit"]');
  const fields = Array.from(form.querySelectorAll('input'));

  // LEaving this in for future use
  // if (isMobileScreen()) setHeaderHeight(header); 
  inputs?.forEach((input) => inputHandler(input, () => checkIfFormIsValid(submitButton, fields)));

  if (checkbox.length) checkbox.forEach((checkbox) => checkboxHandler(checkbox, () => checkIfFormIsValid(submitButton, fields)));

  form.addEventListener('submit', (e) => {onFormSubmit(e, fields, formContainer, form);});
};

export default onProductQualificationLoad;
